/* Celadon Matcha — Hero Carousel section behaviour
   Supports multiple instances per page and the Shopify theme editor
   (section:load/unload, section:select, block:select). */

(function () {
  'use strict';

  function HeroCarousel(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hc-slide]'));
    this.tracksEl = root.querySelector('[data-hc-tracks]');
    this.countCurrent = root.querySelector('[data-hc-count-current]');
    this.current = 0;
    this.timer = null;
    this.paused = false;
    this.autoplay = root.dataset.autoplay !== 'false';

    if (!this.slides.length) return;

    this.buildTracks();
    this.bindEvents();
    this.render();
    this.schedule();
  }

  HeroCarousel.prototype.buildTracks = function () {
    if (!this.tracksEl) return;
    var self = this;
    this.slides.forEach(function (slide, i) {
      var track = document.createElement('button');
      track.type = 'button';
      track.className = 'hero-carousel__track';
      track.setAttribute('role', 'tab');
      track.setAttribute('aria-label', 'Slide ' + (i + 1));
      track.innerHTML = '<span class="hero-carousel__track-fill"></span>';
      track.addEventListener('click', function () { self.goTo(i); });
      self.tracksEl.appendChild(track);
    });
    this.trackEls = Array.prototype.slice.call(this.tracksEl.children);
  };

  HeroCarousel.prototype.bindEvents = function () {
    var self = this;
    this.root.addEventListener('mouseenter', function () { self.pause(); });
    this.root.addEventListener('mouseleave', function () { if (self.autoplay) self.resume(); });
  };

  HeroCarousel.prototype.render = function () {
    var self = this;
    this.slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === self.current);
    });
    if (this.trackEls) {
      this.trackEls.forEach(function (t, i) {
        t.classList.toggle('is-active', i === self.current);
        var duration = parseInt(self.slides[self.current].dataset.duration, 10) || 6000;
        t.style.setProperty('--hc-duration', (duration / 1000) + 's');
      });
    }
    if (this.countCurrent) {
      this.countCurrent.textContent = String(this.current + 1).padStart(2, '0');
    }
  };

  HeroCarousel.prototype.next = function () {
    this.current = (this.current + 1) % this.slides.length;
    this.render();
    this.schedule();
  };

  HeroCarousel.prototype.goTo = function (i) {
    this.current = i;
    this.render();
    this.schedule();
  };

  HeroCarousel.prototype.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    if (this.paused || !this.autoplay) return;
    var duration = parseInt(this.slides[this.current].dataset.duration, 10) || 6000;
    this.timer = setTimeout(function () { self.next(); }, duration);
  };

  HeroCarousel.prototype.pause = function () {
    this.paused = true;
    clearTimeout(this.timer);
  };

  HeroCarousel.prototype.resume = function () {
    this.paused = false;
    this.schedule();
  };

  HeroCarousel.prototype.destroy = function () {
    clearTimeout(this.timer);
  };

  var instances = {};

  function bindLocaleForms(container) {
    var selects = container.querySelectorAll('[data-hc-locale-submit]');
    selects.forEach(function (select) {
      if (select.dataset.hcBound) return;
      select.dataset.hcBound = 'true';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });

    var disclosures = container.querySelectorAll('[data-hc-locale]');
    disclosures.forEach(function (details) {
      if (details.dataset.hcBound) return;
      details.dataset.hcBound = 'true';
      document.addEventListener('click', function (e) {
        if (details.open && !details.contains(e.target)) {
          details.removeAttribute('open');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && details.open) {
          details.removeAttribute('open');
        }
      });
    });
  }

  function init(container) {
    var sections = container.querySelectorAll('.hero-carousel');
    sections.forEach(function (el) {
      var id = el.dataset.sectionId;
      if (instances[id]) instances[id].destroy();
      instances[id] = new HeroCarousel(el);
    });
    bindLocaleForms(container);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  // Theme editor integration
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('.hero-carousel');
    if (el && instances[el.dataset.sectionId]) {
      instances[el.dataset.sectionId].destroy();
      delete instances[el.dataset.sectionId];
    }
  });

  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector('.hero-carousel');
    if (el && instances[el.dataset.sectionId]) instances[el.dataset.sectionId].pause();
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target.querySelector('.hero-carousel');
    if (el && instances[el.dataset.sectionId]) instances[el.dataset.sectionId].resume();
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-hc-slide]');
    var root = e.target.closest('.hero-carousel');
    if (!slide || !root) return;
    var inst = instances[root.dataset.sectionId];
    if (!inst) return;
    inst.pause();
    inst.goTo(parseInt(slide.dataset.index, 10));
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('.hero-carousel');
    if (!root) return;
    var inst = instances[root.dataset.sectionId];
    if (inst) inst.resume();
  });
})();